module.exports = __webpack_public_path__ + "static/media/Sanchit_Shahare.4718d156.jpeg";